import type {
	CURRENCYCODETYPE,
	IBeneficiary,
	IRequestPaymentReqData,
	NetworkType,
	TokenType,
	TRANSACTION_TYPE,
} from 'BreetHelpers';

export type VERIFYTRANSACTIONSTAGETYPE = 'pin-verification' | 'otp-verification' | 'recovery-code' | 'exhausted-recovery-code';

export const verifyTransactionTitle: Record<VERIFYTRANSACTIONSTAGETYPE, string> = {
	'pin-verification': 'PIN Verification',
	'otp-verification': 'Verification',
	'recovery-code': 'Recovery Code',
	'exhausted-recovery-code': 'Recovery Code Exhausted',
};

export interface IDIALOGVERIFYTRANSACTIONPROPS {
	transactionType: TRANSACTION_TYPE;
	skipPin?: boolean;
	withdrawFiatReqData?: IRequestPaymentReqData;
	convertFiatToUSDReqData?: {
		amount: number;
		withdrawalAddressId?: string;
		pin?: string;
	};
	reqDataInfo?: {
		to: CURRENCYCODETYPE;
		from: CURRENCYCODETYPE;
		beneficiary: Partial<IBeneficiary>;
		receiverAddress?: string;
		token?: string;
		network?: string;
	};
	swapCurrencyReqData?: {
		amount: number;
		from: Lowercase<CURRENCYCODETYPE>;
		to: Lowercase<CURRENCYCODETYPE>;
		pin?: string;
	};
	withdrawUSDReqData?: {
		amount: number;
		walletId: string;
		pin?: string;
	};
	saveWalletAddressReqData?: {
		address: string;
		token: TokenType;
		network: NetworkType;
		label: string;
	};
	updateAutoSettlementReqData?: {
		bankId: string;
	};
	disableAutoSettlementReqData?: {
		bankId: string;
	};
	sellUsdReqData?: {
		amount: number;
		currency: Lowercase<CURRENCYCODETYPE>;
		bank?: string;
	};
}
